import React from 'react';
import * as styles from './talent-analytics-dashboard.module.scss';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { TA_DASHBOARD_CATEGORIES, TA_DETAIL_PATH } from './talent-analytics.constant';
import { PETRONAS_Logo_Dashboard } from '../../assets/img';
import { BI_DASHBOARD_TYPE } from '../Dashboard/PowerBIDashboard';

const TalentAnalyticsDashboards = () => {
  const history = useHistory();

  const onChangeTab = (path, tabNumber) => {
    if ([TA_DASHBOARD_CATEGORIES[0].path].includes(path) && tabNumber == 0) {
      history.push(`${TA_DETAIL_PATH}/${path}?page=${BI_DASHBOARD_TYPE.SUCCESSION_PLANNING_OVERVIEW.key}`);
      // history.push(`/talent-analytics-bi-dashboard?page=${BI_DASHBOARD_TYPE.SUCCESSION_PLANNING_OVERVIEW.key}`);
    } else if ([TA_DASHBOARD_CATEGORIES[0].path].includes(path) && tabNumber == 1) {
      history.push(`${TA_DETAIL_PATH}/${path}?page=${BI_DASHBOARD_TYPE.TALENT_OVERVIEW.key}`);
      // history.push(`/talent-analytics-bi-dashboard?page=${BI_DASHBOARD_TYPE.TALENT_OVERVIEW.key}`);
    } else {
      history.push(`${TA_DETAIL_PATH}/${path}?tab=${tabNumber}`);
    }
  };

  return (
    <div className={styles.dashboard_container}>
      <div className={styles.main_title}>
        <img className={styles.main_logo} src={PETRONAS_Logo_Dashboard} alt="" />
        <span>Talent Analytics Dashboards</span>
      </div>
      {TA_DASHBOARD_CATEGORIES.map((item) => (
        <>
          <div key={item.key} className={styles.section_wrap}>
            <h3 className={styles.section_title}>{item.label}</h3>
            <div className={styles.section_list}>
              {item.children.map((c, cIndex) => (
                <div key={c.key} className={styles.section_item} onClick={() => onChangeTab(item.path, cIndex)}>
                  <img className={styles.section_item_icon} src={c.image} alt="" />
                  <div className={styles.section_item_info}>
                    <div className={styles.section_item_title}>{c.label}</div>
                    {/* <div className={styles.section_item_desc}>{c.desc}</div> */}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <br />
        </>
      ))}
    </div>
  );
};

export default TalentAnalyticsDashboards;
